import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { getSettings, saveSettings } from '../../services/api';
import { FaArrowRight, FaSave } from 'react-icons/fa';

const Container = styled.div`
  padding: 2rem;
  direction: rtl;
  min-height: 80vh;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #8B0000;
`;

const Title = styled.h1`
  color: #8B0000;
  font-size: 2rem;
`;

const BackButton = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: #666;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  transition: background 0.3s;
  &:hover { background: #555; }
`;

const SectionCard = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: #8B0000;
  font-size: 1.4rem;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #eee;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;

  &:last-child { margin-bottom: 0; }
`;

const Label = styled.label`
  color: #333;
  font-weight: 500;
  font-size: 0.95rem;
`;

const TextArea = styled.textarea`
  padding: 0.75rem;
  border: 2px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  min-height: 120px;
  resize: vertical;
  font-family: inherit;
  &:focus { outline: none; border-color: #8B0000; }
`;

const SaveButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 2rem;
  background: #8B0000;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background 0.3s;
  &:hover { background: #3f0101; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

const SuccessMsg = styled.p`
  color: #4CAF50;
  font-size: 1rem;
  margin-top: 0.5rem;
`;

const defaultAbout: Record<string, string> = {
  about_history: '',
  about_mission: '',
  about_values: '',
};

const ManageAbout: React.FC = () => {
  const [fields, setFields] = useState<Record<string, string>>(defaultAbout);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    getSettings()
      .then(res => setFields({ ...defaultAbout, ...res.data }))
      .catch(() => {});
  }, []);

  const set = (key: string, value: string) =>
    setFields(prev => ({ ...prev, [key]: value }));

  const handleSave = async () => {
    setLoading(true);
    setSaved(false);
    try {
      await saveSettings(fields);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch {
      alert('حدث خطأ أثناء حفظ المحتوى');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Header>
        <Title>إدارة "عن كنيستنا"</Title>
        <BackButton to="/admin/dashboard"><FaArrowRight /> العودة</BackButton>
      </Header>

      <SectionCard>
        <SectionTitle>تاريخ الكنيسة</SectionTitle>
        <FormGroup>
          <Label>النص الذي يظهر في صفحة "عن كنيستنا"</Label>
          <TextArea value={fields.about_history} onChange={e => set('about_history', e.target.value)} />
        </FormGroup>
      </SectionCard>

      <SectionCard>
        <SectionTitle>رسالتنا</SectionTitle>
        <FormGroup>
          <Label>النص الذي يظهر في صفحة "عن كنيستنا"</Label>
          <TextArea value={fields.about_mission} onChange={e => set('about_mission', e.target.value)} />
        </FormGroup>
      </SectionCard>

      <SectionCard>
        <SectionTitle>قيمنا</SectionTitle>
        <FormGroup>
          <Label>النص الذي يظهر في صفحة "عن كنيستنا"</Label>
          <TextArea value={fields.about_values} onChange={e => set('about_values', e.target.value)} />
        </FormGroup>
      </SectionCard>

      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <SaveButton onClick={handleSave} disabled={loading}>
          <FaSave /> {loading ? 'جاري الحفظ...' : 'حفظ المحتوى'}
        </SaveButton>
        {saved && <SuccessMsg>تم الحفظ بنجاح!</SuccessMsg>}
      </div>
    </Container>
  );
};

export default ManageAbout;
